import { callWidgetController } from '@/modules/Widget/helpers/widgetController';

export default class McWidget {
  static openLauncher() {
    callWidgetController('openLauncher');
  }
}
